const serviceConfig = {
  name: 'Service',
  endpoint: '/internal_admin/admin_kit/services',

  columns: [
    { name: 'oem', title: 'OEM' },
    { name: 'name', title: 'Name', type: 'link' },
    { name: 'app_name', title: 'App Name' },
    { name: 'description', title: 'Description' },
  ],

  filters: [
    { name: 'q[name_cont]', label: 'Name' },
    { name: 'q[oem_cont]', label: 'OEM' },
    { name: 'q[app_name_cont]', label: 'App Name' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'oem', label: 'OEM' },
    { name: 'name', label: 'Name' },
    { name: 'app_name', label: 'App Name' },
    { name: 'description', label: 'Description' },
    { name: 'tenant_uri', label: 'Tenant URI' },
    { name: 'application_uri', label: 'Application URI' },
    { name: 'updated_at', label: 'Updated At' },
  ],
};

export default serviceConfig;
